import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
  },
  modalView: {
    display: "flex",
    flexDirection: "column",
    width: 600,
    maxWidth: "100%",
    maxHeight: "calc(100% - 32px)",
    backgroundColor: theme.palette.background.paper,
    borderRadius: 20,
    padding: 24,
    boxSizing: "border-box",
    boxShadow: "0 24px 80px rgba(0, 0, 0, 0.2)",
    outline: "none",
    [theme.breakpoints.down("xs")]: { padding: 16 },
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
    flexShrink: 0,
  },
  heading: { minWidth: 0 },
  title: { fontSize: 22, fontWeight: 700, lineHeight: 1.3 },
  customer: {
    fontSize: 16, fontWeight: 500, marginTop: 12, overflowWrap: "anywhere"
  },
  date: { fontSize: 13, color: "#65656F", marginTop: 4 },
  closeButton: { padding: 10, marginTop: -6, marginRight: -6 },
  readOnlyNotice: {
    alignSelf: "flex-start",
    fontSize: 12,
    color: "#555560",
    backgroundColor: "#F2F2F5",
    borderRadius: 8,
    padding: "6px 10px",
    marginTop: 16,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: "#65656F",
    marginTop: 24,
    marginBottom: 8,
  },
  items: { minHeight: 0, overflowY: "auto", overscrollBehavior: "contain" },
  item: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "16px 0",
    borderTop: "1px solid #EDEDF0",
    [theme.breakpoints.down("xs")]: { gap: 8 },
  },
  name: {
    flex: 1, minWidth: 0, fontSize: 14, fontWeight: 600, overflowWrap: "anywhere"
  },
  price: {
    flexShrink: 0, fontSize: 14, fontWeight: 600, whiteSpace: "nowrap"
  },
  amount: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    minHeight: 36,
    borderRadius: 8,
    backgroundColor: "#F4F4F6",
    "& span": {
      fontSize: 14, fontWeight: 600, minWidth: 32, textAlign: "center"
    },
  },
  icon: {
    padding: 8,
    "& svg": { height: 18, width: 18, color: "#65656F" },
  },
  footer: {
    flexShrink: 0, borderTop: "1px solid #E5E5EA", paddingTop: 20, marginTop: 8
  },
  total: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& span": { fontSize: 20, fontWeight: 700 },
  },
  actions: {
    display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: 12, marginTop: 24
  },
  observation: {
    marginTop: 4,
    "& span": {
      fontSize: 12, color: "#65656F", overflowWrap: "anywhere", whiteSpace: "normal"
    },
  },
  details: {
    display: "flex", flexDirection: "column", flex: 1, minWidth: 0
  },
}));

export default useStyles;
